import { render, staticRenderFns } from "./AccesibilityToolbar.vue?vue&type=template&id=6dd03f44&scoped=true&"
import script from "./AccesibilityToolbar.vue?vue&type=script&lang=js&"
export * from "./AccesibilityToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AccesibilityToolbar.vue?vue&type=style&index=0&id=6dd03f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd03f44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VSpacer})
